import { render, staticRenderFns } from "./contact-details-review.vue?vue&type=template&id=7dc86548&lang=pug"
import script from "./contact-details-review.vue?vue&type=script&lang=ts"
export * from "./contact-details-review.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports